import { pdf } from "@react-pdf/renderer";
import toast from "react-hot-toast";
import { PaymentReceiptPDF } from "./PaymentReceiptPDF";

export interface PaymentPDFData {
  customerName: string;
  paymentAmount: number;
  paymentDate: string;
  coApplicantName?: string;
}

export const generatePaymentPDF = async (
  paymentData: PaymentPDFData,
): Promise<void> => {
  try {
    const generatedDate = new Date().toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    const pdfDocument = (
      <PaymentReceiptPDF
        paymentData={paymentData}
        generatedDate={generatedDate}
      />
    );

    const pdfBlob = await pdf(pdfDocument).toBlob();
    const url = URL.createObjectURL(pdfBlob);

    // Create download link
    const downloadLink = document.createElement("a");
    downloadLink.href = url;
    downloadLink.download = `${paymentData.customerName}-payment.pdf`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    toast.success("Payment receipt PDF generated successfully!");
  } catch (error) {
    console.error("Error generating payment PDF:", error);
    toast.error("Failed to generate payment receipt PDF");
  }
};
